module.exports = __webpack_public_path__ + "media/images/playcanvas_icon-2c84c5e4f63516c3df56cc6ff7e15934.png";